module.exports = __webpack_public_path__ + "img/order_invalid_move.584ca802.png";